<template>
  <div class="page__container">
    <header class="header__container">
      <img class="header__image" src="/img/logo_mark.png" />
    </header>

    <section class="content__container">
      <div class="main-image__container">
        <img class="main-image" src="/img/avatars.webp" />
      </div>

      <div class="message__container">
        <h1 class="message__title">
          {{ $t('transferSuccessMessage') }}
        </h1>
      </div>

      <div class="button__container">
        <PrimaryButton @click="onClickToTopPageButton">{{
          $t('returnToHomePage')
        }}</PrimaryButton>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import { LanguageQueryHandler } from '@/mixins/LanguageQuery'
import PrimaryButton from '@/components/PrimaryButton.vue'

@Component({
  components: {
    PrimaryButton,
  },
  beforeRouteEnter: async function (_to, from, next) {
    // TODO: 一時的にコメントアウト
    // const transitions = ['wise']
    // if (!from.name || !transitions.includes(from.name)) {
    //   return next({ name: 'wise' })
    // }
    // TODO: beforeRouteEnterでIPチェックを行う
    next()
  },
})
export default class WiseSuccess extends Mixins(LanguageQueryHandler) {
  onClickToTopPageButton(): void {
    this.$router.push('/mypage').catch(() => {})
  }
}
</script>

<style scoped>
.content__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header__container {
  display: flex;
  justify-content: center;
}

.header__image {
  height: 44px;
  width: 120px;
}

.main-image__container {
  display: inline-block;
}

.main-image {
  width: 100%;
}

.message__container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding-top: 24px;
  padding-bottom: 24px;
}

.message__title {
  font-family: 'Hiragino Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  color: #262626;
  display: inline-block;
  padding-top: 8px;
  padding-bottom: 8px;
}

.button__container {
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  flex-direction: column;
}
</style>
